import { TenantFeatureItemDto } from '../../tenant-feature-items/dtos/tenant-feature-item.dto';

export class TenantSettingsMarketingDto {
  features?: TenantFeatureItemDto[] | null;
}
